export const HERO_CONSTANTS = {
  heading: "Launch. Connect. Grow.",
  title: "OneMind AppSpace",
  subText: "Empower your vision with visibility and purpose.",
  btn1: {
    label: "Browse AppSpace",
    link: "app-space",
  },
  btn2: {
    label: "Partner with Us",
    link: "contact-us",
  },
  image: "/marketplace-apps/HeroBg.png",
};
